import { render, staticRenderFns } from "./ValidateUser.vue?vue&type=template&id=7971ba18&scoped=true&"
import script from "./ValidateUser.vue?vue&type=script&lang=js&"
export * from "./ValidateUser.vue?vue&type=script&lang=js&"
import style0 from "./ValidateUser.vue?vue&type=style&index=0&id=7971ba18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971ba18",
  null
  
)

export default component.exports